import React from 'react'
import './index.css'

interface Props {
	title: string
	onClick?: () => void
	variant?: 'primary' | 'secondary' | 'outline'
	size?: 'small' | 'medium' | 'large'
	disabled?: boolean
	type?: 'button' | 'submit'
	fullWidth?: boolean
}

const PlanerBtn: React.FC<Props> = ({
	title,
	onClick,
	variant = 'primary',
	size = 'medium',
	disabled = false,
	type = 'button',
	fullWidth = false
}) => {
	return (
		<button
			type={type}
			disabled={disabled}
			onClick={onClick}
			className={`planer-btn planer-btn-${variant} planer-btn-${size} ${fullWidth ? 'planer-btn-full' : ''} ${disabled ? 'planer-btn-disabled' : ''}`}
		>
			{title}
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className="planer-btn-arrow"
			>
				<path
					d="M12.5625 5.25L19.3125 12L12.5625 18.75M18.375 12H4.6875"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	)
}

export default PlanerBtn
